export interface IAppStore {
  [stateName: string]: any;
}

export const reducers: any = {}; // updated from the modules loader (only)
